import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { HttpErrorResponse } from "@angular/common/http";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { EmitterService } from "app/Shared/Services/emitter.service";
import { Subscription } from "rxjs";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BaseChartDirective } from "ng2-charts";
import { ChartConfiguration } from 'chart.js';
import { DatePipe } from "@angular/common";

@Component({
    selector: 'app-cat-report',
    imports: [DatePipe, MatProgressSpinnerModule, BaseChartDirective],
    templateUrl: './cat-report.component.html',
    styleUrls: ['./cat-report.component.scss']
})
export class CatReportComponent implements OnInit,OnDestroy {
  LastCATExecutionDate:any;
  isLoadingResults!: boolean;
  public dateLabelsArray: any = [' ', ' ', ' ', ' ', ' '];
  subscription!: Subscription;
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;
 
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 0,
    scaleValuePaddingY: 0,
    barPercentage: 1,
    categoryPercentage: 1,
  
    scales: {
      y:{
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 6,
          stepSize: 1,

          // Create Numberic notation labels
          callback: function (value:any, index:any, values:any) {
            if (value >= 1000 && value < 1000000) {
              value = value / 1000 + ' K';
            }
            if (value >= 1000000) {
              value = value / 1000000 + ' M';
            }
            return value;
          }
        },
      },
      x:{
        scrollbar: {
          enabled: true
        }
      }
    },
    tooltips:  //  false,
    {
      enabled: true,
      backgroundColor: 'Black',
      textColor: 'black',
      opacity: 1
    },
    animations: {
      tension: {
        duration: 100,
        easing: 'linear',
        from: 1,
        to: 0,
        loop: true
      }
    },
    plugins: {
      colors: {
        enabled: true
      },
      datalabels: { 
       display: false
      },
    },  
  };
  public barChartLabels: string[] = this.dateLabelsArray;
  public barChartType: any = 'bar';
  public chartColors: Array<any> = [
    { // first color
      backgroundColor:  '#b2ffb2',
      borderColor: 'rgba(225,10,24,0.2)',
      pointBackgroundColor: 'rgba(225,10,24,0.2)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(225,10,24,0.2)'
    },
    { // second color
      backgroundColor:  '#ffb2b2',
      borderColor: 'rgba(225,10,24,0.2)',
      pointBackgroundColor: 'rgba(225,10,24,0.2)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(225,10,24,0.2)'
    }];

    

  public barChartData: any[] = [
    {
      label: "Accpeted",
      data: [0,0,0,0,0],
      categoryPercentage: 0.8,
      barPercentage:0.5,
      fill:false,
      stack:'a',
      backgroundColor:'#b2ffb2'
    },
    {
      label: "Skipped",
      data: [0,0,0,0,0],
      categoryPercentage: 0.8,
      barPercentage:0.5,
      fill:false,
      stack:'a',
      backgroundColor: '#ffb2b2',
    }
  ];

  public chartData: ChartConfiguration<'bar'>['data'] = {
    labels: this.barChartLabels,
    datasets: this.barChartData
  }
  
  constructor(
    private UrlsService: UrlsService,
    public UserService: UserService,
    private SharedHttpClientService: SharedHttpClientService,
    private EmitterService: EmitterService,
    public date:DatePipe) {
    this.LastCATExecutionDate = null;
  }
  ngOnInit() {
    /*** Get Last CAT Execution date*/
    this.LastCATExecutionDate = this.UserService.CATDashboard_LastExecutionDate;
    this.getData();
    this.subscription = this.EmitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.isLoadingResults = true;
        this.UserService.get_CAT_Last_ReportDate().subscribe((res: any) => {
          let response: any = res;
          let jsondata = response.data[0]
          if(jsondata) {
            this.LastCATExecutionDate = jsondata.CATLastExcecutionReportDate !=="" ? this.UserService.getFormatedDate(jsondata.CATLastExcecutionReportDate) : new Date();
            this.getData();
          }
        });
      }
    });
  }

  getData() {
    this.isLoadingResults = true;
    this.SharedHttpClientService.post(
      this.UrlsService.setAPIURl(APIURL.CAT_Dash_Report_File_Details),
      {
        mpid: this.UserService.getActiveMPID()
      })
      .subscribe({
        next: (response:any) => {
        this.isLoadingResults = false;
        let dataset: any = response;
        this.UserService.ReceivedFilesCount = dataset.ReceivedFilesCount != null ? dataset.ReceivedFilesCount : 0;
        this.UserService.CATFinraSubmittedFileCount = dataset.CATFinraSubmittedFileCount != null ? dataset.CATFinraSubmittedFileCount : 0;
        this.UserService.CATPreValidationROECount = dataset.CATPreValidationROECount != null ? dataset.CATPreValidationROECount : 0;
        this.UserService.CATFinraRejectsROECount = dataset.CATFinraRejectsROECount != null ? dataset.CATFinraRejectsROECount : 0;
        let acceptedCount: Array<any> = [0,0,0,0,0];
        let rejectedCount: Array<any> = [0,0,0,0,0];
       
       if(dataset.graphData.length> 0) {
        dataset.graphData.forEach((element:any, index:any) => {
          if(index < 5) {
            acceptedCount[index] = (element.acceptedCount);
            rejectedCount[index] = (element.rejectCount);
            this.barChartLabels[index] = (element.groupName);
            this.getBarChartLabels(element.groupName, index);           
          } else {
            acceptedCount.push(element.acceptedCount);
            rejectedCount.push(element.rejectCount);
            this.barChartLabels.push(element.groupName);
            this.getBarChartLabels(element.groupName, index);
          }
        });
       }        
        this.barChartData = [
          {
            label: "Accepted",
            data: acceptedCount,
            categoryPercentage: 0.8,
            barPercentage:0.5,
            fill:false,
            stack:'a',
            backgroundColor:'#b2ffb2'
          },
          {
            label: "Skipped",
            data: rejectedCount,
            categoryPercentage: 0.8,
            barPercentage:0.5,
            fill:false,
            stack:'a',
            backgroundColor: '#ffb2b2',
          }
        ];
        this.chartData = {
          labels: this.barChartLabels,
          datasets: this.barChartData
        }
        },
        error: (err: HttpErrorResponse) => {
          this.isLoadingResults = false;
        }
      });  
  }

  getBarChartLabels(label: any, index:number) {
    if(index !== 0 && this.barChartLabels[index -1].split(' ')[0] === label.split(' ')[0]) {
      label = label.replace(label.split(' ')[1], parseInt(this.barChartLabels[index -1].split(' ')[1]) + 1);
      this.barChartLabels[index] = label;      
      }
  }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}
